module.exports = __webpack_public_path__ + "static/img/p19.da89088.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/p19.png
// module id = akMp
// module chunks = 0